module.exports = __webpack_public_path__ + "static/media/test3_1.e32a9757.png";